<template>
  <div class="select-material-modal">
    <div class="search-section">
      <q-input
        v-model="searchText"
        outlined
        dense
        placeholder="Поиск по названию или артикулу..."
        clearable
        autofocus
        class="search-input"
        @update:model-value="onSearchChange"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>

    <q-linear-progress v-if="loading" indeterminate color="primary" />

    <div class="materials-list">
      <template v-if="materials.length">
        <div
          v-for="material in materials"
          :key="material.material_id"
          class="material-item"
          :class="{ 'selected': selectedMaterial?.material_id === material.material_id }"
          @click="selectMaterial(material)"
        >
          <div class="material-info">
            <span class="material-name">ID:{{ material.material_id }} {{ material.material_name }}</span>
            <span class="material-meta">
              <span v-if="material.vendor_code" class="vendor-code">{{ material.vendor_code }}</span>
              <span v-if="material.material_type_name" class="material-type">{{ material.material_type_name }}</span>
            </span>
          </div>
          <q-icon v-if="selectedMaterial?.material_id === material.material_id" name="check_circle" color="positive" size="20px" />
        </div>
      </template>

      <div v-else class="no-materials">
        <q-icon name="inventory_2" size="48px" color="grey-4" />
        <div class="empty-text">{{ noMaterialsText }}</div>
      </div>
    </div>

    <!-- Кнопки -->
    <div class="actions-section">
      <q-btn flat label="Сбросить" color="grey-7" @click="clearSelection" />
      <q-btn flat label="Отмена" color="grey-7" @click="closeModal" />
      <q-btn 
        color="primary" 
        label="Выбрать" 
        @click="confirmSelection"
        :disable="!selectedMaterial"
      />
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/services/store/app";
import { getMaterials } from "@/views/SupplierRequests/services";

export default {
  name: "SelectMaterial",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      searchText: "",
      materials: [],
      selectedMaterial: null,
      searchTimeout: null,
    };
  },
  computed: {
    noMaterialsText() {
      if (this.searchText) {
        return 'Материалы не найдены';
      }
      return 'Нет материалов';
    }
  },
  methods: {
    onSearchChange() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.loadMaterials();
      }, 300);
    },
    async loadMaterials() {
      this.loading = true;
      try {
        this.materials = await getMaterials(this.searchText || '', 100);
      } catch (e) {
        console.error('Error loading materials:', e);
        this.materials = [];
      }
      this.loading = false;
    },
    selectMaterial(material) {
      this.selectedMaterial = material;
    },
    clearSelection() {
      this.selectedMaterial = null;
    },
    confirmSelection() {
      if (this.data?.onSelect) {
        this.data.onSelect(this.selectedMaterial);
      }
      this.closeModal();
    },
  },
  mounted() {
    if (this.data?.material_id) {
      this.selectedMaterial = { material_id: this.data.material_id };
    }
    this.loadMaterials();
  },
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  setup() {
    const { closeModal } = useAppStore();
    return { closeModal };
  }
};
</script>

<style scoped lang="scss">
.select-material-modal {
  width: 600px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.search-section {
  margin-bottom: 16px;
}

.search-input {
  width: 100%;
}

.materials-list {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: 400px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.material-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  background: white;
  transition: all 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #e3f2fd;
  }

  &.selected {
    background: #e8f5e9;
    border-left: 3px solid #4caf50;
  }
}

.material-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.material-name {
  font-weight: 500;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #6c757d;
}

.vendor-code {
  color: #1976d2;
  font-weight: 500;
}

.no-materials {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #9e9e9e;
}

.empty-text {
  margin-top: 12px;
  font-size: 14px;
}

.actions-section {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
</style>
